import { Color, Radio } from "@mui/material";
import { green, grey } from "@mui/material/colors";

interface CustomRadioProps {
  size?: "small" | "medium";
  checked: boolean;
  onClick: () => void;
  value: any;
  color?: Color;
  colorWeight?: 50 | 100 | 200 | 300 | 400 | 500 | 600 | 800 | 900 | "A100" | "A200" | "A400" | "A700";
}

const CustomRadio: React.FC<CustomRadioProps> = (props) => {
  return (
    <Radio
      onClick={props.onClick}
      size={props.size ? props.size : "small"}
      checked={props.checked}
      value={props.value}
      sx={{
        color: grey[props.colorWeight ? props.colorWeight : 800],
        "&.Mui-checked": {
          color: props.color ? props.color[props.colorWeight ? props.colorWeight : 400] : green[300],
        },
      }}
    />
  );
};

export default CustomRadio;
